export default __webpack_public_path__ + "static/media/banner.18cf8bdb.png";